// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__B8gWF","title":"ClientInsurance_title__3Xk-t","itemText":"ClientInsurance_itemText__2k6fP"};